// extracted by mini-css-extract-plugin
export default {"container":"add-patients-from-bst_container__crP2R","btns-container":"add-patients-from-bst_btns-container__I0IPB"};